// extracted by mini-css-extract-plugin
module.exports = {"fixedContainer":"generic_fixed_bar-module--fixedContainer--b_bSm"};